import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, FileMeta, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateString } from '/imports/validators';
import { strings } from '/imports/strings';

export const SupportTicketStatuses = {
  awaitingSupport: 'awaitingSupport',
  awaitingUser: 'awaitingUser',
  closed: 'closed',
};

export interface SupportTicket extends Doc {
  _id: string;
  subject: string;
  description: string;
  caseNumber: string;
  userId: string;
  status: string;
  files?: FileMeta[];
}
export type Model = SupportTicket;

export const SupportTickets = new Mongo.Collection<SupportTicket>('supportTickets');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: SupportTickets,
  editableFields: [
    'active', 'subject', 'description', 'caseNumber', 'userId', 'status', 'files',
  ],
  isOrgOwned: true,
  listMethod: DeclareMethod<ListMethodArg<SupportTicket>, ListMethodResponse<SupportTicket, Refs>>('listSupportTickets'),
  getMethod: DeclareMethod<string, GetMethodResponse<SupportTicket, Refs>>('getSupportTicket'),
  createMethod: DeclareMethod<Partial<SupportTicket>, string>('createSupportTicket'),
  updateMethod: DeclareMethod<Partial<SupportTicket>, string>('updateSupportTicket'),
  deleteMethod: DeclareMethod<string>('deleteSupportTicket'),
  pathPrefix: '/support',
  asString: (document) => document.caseNumber,
  modelName: strings.SupportTicket(),
  pluralName: strings.SupportTickets(),
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { subject: new RegExp(search, 'gi') },
        { caseNumber: new RegExp(search, 'gi') },
      ]
    };
  },
  validate: async (set: Partial<SupportTicket>) => {
    const errors: { [key: string]: string[] } = {};
    validateString(errors, set, 'subject', { required: true });
    validateString(errors, set, 'caseNumber', { required: true });
    validateString(errors, set, 'userId', { required: true });
    validateString(errors, set, 'status', { required: true });
    validateString(errors, set, 'description', { required: true });
    return errors;
  },
};

Meteor.isServer && Meteor.startup(async () => {
  await SupportTickets.createIndexAsync({ userId: 1 });
  await SupportTickets.createIndexAsync({ caseNumber: 1 });
  await SupportTickets.createIndexAsync({ subject: 1 });
});
